import { gsap } from "gsap";

const onSaleSection = document.querySelector<HTMLElement>(".onSale");

if (onSaleSection) {
  const coverTitles = onSaleSection?.querySelector<HTMLElement>(".onSale-titles");
  const coverContent = onSaleSection?.querySelector<HTMLElement>(".onSale-cover-content");

  const titles: NodeListOf<HTMLElement> =
    (coverTitles && coverTitles.querySelectorAll<HTMLElement>(".onSale-titles-item")) ||
    document.querySelectorAll<HTMLElement>(".onSale-titles-item");

  titles.forEach((title) => {
    title.addEventListener("mouseenter", (event) => {
      const target = event.target as HTMLElement;
      const idx = target.getAttribute("data-idx");

      const correspondingElement = document.querySelector<HTMLElement>(
        `.onSale-cover-image[data-for-idx="${idx}"]`
      );

      if (correspondingElement) {
        gsap.to(correspondingElement, { opacity: 1, duration: 0.5 });
        target.classList.add("active");
        onSaleSection?.classList.remove("default");

        if (idx && Number(idx) > 0) {
          gsap.to(coverContent, { opacity: 0, duration: 0.5 });
        }
      }
    });

    title.addEventListener("mouseleave", (event) => {
      const target = event.target as HTMLElement;
      const idx = target.getAttribute("data-idx");

      const correspondingElement = document.querySelector<HTMLElement>(
        `.onSale-cover-image[data-for-idx="${idx}"]`
      );

      if (correspondingElement) {
        onSaleSection?.classList.add("default");
        target.classList.remove("active");

        if (idx && Number(idx) > 0) {
          gsap.to(correspondingElement, { opacity: 0, duration: 0.5 });
          gsap.to(coverContent, { opacity: 1, duration: 0.5 });
        }
      }
    });
  });
}

const onSaleCoverImages = document.querySelector<HTMLElement>(".featured-onSale-cover-image picture");
if (onSaleCoverImages) {
  setTimeout(() => {
    onSaleCoverImages.classList.add("animate-in");
  }, 500)
}
